const HomePageConfigTypes = {
  GET_HOME_PAGE_PERMISSION: "GET_HOME_PAGE_PERMISSION",
  GET_HOME_PAGE_PERMISSION_SUCCESS: "GET_HOME_PAGE_PERMISSION_SUCCESS",
}

export default HomePageConfigTypes
